import React, { useState } from "react";
import { Row, Col, Container, Table } from "react-bootstrap";
import Menubar from "./Menubar.jsx";
import { AiOutlineSearch } from "react-icons/ai";
export default function KPIDashboard() {

  // let roleid = localStorage.getItem("role");
  let deptname = localStorage.getItem("deptName");
  let dashboardDataForSwarnaAndhraKPIslist = JSON.parse(localStorage.getItem("dashboardDataForSwarnaAndhraKPIslist"));

  let mandal_indicators = localStorage.getItem("mandal_indicators");
  let district_indicators = localStorage.getItem("district_indicators");
  let annually = localStorage.getItem("annually");
  let bi_annual = localStorage.getItem("bi_annual");
  let five_years = localStorage.getItem("five_years");

  let half_yearly = localStorage.getItem("half_yearly");
  let monthly = localStorage.getItem("monthly");
  let quarterly = localStorage.getItem("quarterly");
  let secretariat_indicators = localStorage.getItem("secretariat_indicators");
  let state_indicators = localStorage.getItem("state_indicators");
  let total = localStorage.getItem("total");
    let role_cat_id = localStorage.getItem("catid");


  const [search1, setSearch1] = useState("");

  const filteredData1 =
    dashboardDataForSwarnaAndhraKPIslist.length > 0 && dashboardDataForSwarnaAndhraKPIslist?.length ? dashboardDataForSwarnaAndhraKPIslist.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(search1.toLowerCase()); }) ); })
      : dashboardDataForSwarnaAndhraKPIslist;


        const [search2, setSearch2] = useState("");const filteredData2 = dashboardDataForSwarnaAndhraKPIslist.length > 0 && dashboardDataForSwarnaAndhraKPIslist?.length ? dashboardDataForSwarnaAndhraKPIslist.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(search2.toLowerCase()); }) ); }) : dashboardDataForSwarnaAndhraKPIslist;
  return (
    <>
      <Menubar />
      <Container fluid className="outer-page-content-container" width="90%" style={{ height: "900px", overflow: "visible" }}>
        {["116","112"].includes(role_cat_id) ? (
          <>
            <Row>
              <div className="sa-title">
                <h2>
                  List Of <span>KPI'S</span>
                </h2>
              </div>
            </Row>
            <Row className=" mb-5">
              
               
              <Col xs={12} sm={12} md={5} lg={5} xl={5} xxl={5}>
              <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=" mt-2 mb-3">
                <div id="search-container" style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} >
                  <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888" }} />
                  <input type="text" placeholder="Search" value={search1} onChange={(event) => setSearch1(event.target.value)} onFocus={() => { const wrapper = document.getElementById("search-container"); wrapper.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; wrapper.style.border = "1px solid #353935"; wrapper.style.width = "30%"; }} onBlur={() => { const wrapper = document.getElementById("search-container"); wrapper.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; wrapper.style.border = "1px solid #ddd"; wrapper.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} />
                </div>
              </Col>
                <div id="table-scroll" className="" style={{ maxHeight: "400px", overflowY: "auto", overflowX: "hidden" }}>
                  <table className="table table-bordered custom-table table-responsive w-100" id="my-table">
                    <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                      <tr className="text-center">
                        <th colSpan="7" style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>
                          <span style={{ color: "black", fontSize: "15px" }}>KPI Entry Level </span>
                        </th>
                      </tr>
                      <tr className="text-center">
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Sl.No.</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }} className="indicator-column">HOD Name</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Mandal</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>District</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>HOD</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Secretariat</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Total</th>

                      </tr>
                    </thead>

                    <tbody>
                      {filteredData1?.length === 0 || filteredData1?.length === undefined ? (
                        <tr>
                          <td className="text-center" colSpan="7">
                            <b style={{ color: "red" }}>Details Not Found</b>
                          </td>
                        </tr>
                      ) : (
                        (() => {
                          return filteredData1?.map((detail, i) => {
                            return (
                              <tr key={i}>
                                <td style={{ textAlign: "center" }}>{i + 1}</td>
                                <td style={{ textAlign: "left", minWidth: "100px", wordWrap: "break-word", whiteSpace: "normal" }} className="indicator-column">{detail.hod_id}<br/>{detail.dept_name}</td>

                                <td style={{ textAlign: "right" }}>{detail.mandal_indicators}</td>
                                <td style={{ textAlign: "right" }}>{detail.district_indicators}</td>

                                <td style={{ textAlign: "right" }}>{detail.state_indicators}</td>
                                <td style={{ textAlign: "right" }}>{detail.secretariat_indicators}</td>
                                <td style={{ textAlign: "right" }}>{detail.mandal_indicators+detail.district_indicators+detail.state_indicators+detail.secretariat_indicators}</td>

                              </tr>
                            );
                          });
                        })()
                      )}
                    </tbody>
                     <tfoot style={{ position: "sticky", bottom: "0px" }}>
    <tr style={{ backgroundColor: "#4e835c", fontWeight: "bold" }}>
      <td colSpan={2} style={{textAlign: "right",backgroundColor: "#4e835c", color: "#fff",}}>Total</td>
      <td style={{textAlign: "right",backgroundColor: "#4e835c", color: "#fff" }}>
        {filteredData1?.reduce((sum, item) => sum + (parseFloat(item.mandal_indicators) || 0), 0)}
      </td>
      <td style={{textAlign: "right",backgroundColor: "#4e835c", color: "#fff" }}>
        {filteredData1?.reduce((sum, item) => sum + (parseFloat(item.district_indicators) || 0), 0)}
      </td>
      <td style={{textAlign: "right",backgroundColor: "#4e835c", color: "#fff" }}>
        {filteredData1?.reduce((sum, item) => sum + (parseFloat(item.state_indicators) || 0), 0)}
      </td>
      <td style={{textAlign: "right",backgroundColor: "#4e835c", color: "#fff" }}>
        {filteredData1?.reduce((sum, item) => sum + (parseFloat(item.secretariat_indicators) || 0), 0)}
      </td>
      <td style={{textAlign: "right",backgroundColor: "#4e835c", color: "#fff"}}>
      {
        filteredData1?.reduce((sum, item) => {
          const rowTotal =
            (parseFloat(item.mandal_indicators) || 0) +
            (parseFloat(item.district_indicators) || 0) +
            (parseFloat(item.state_indicators) || 0) +
            (parseFloat(item.secretariat_indicators) || 0);

          return sum + rowTotal;
        }, 0)
      }
    </td>
    </tr>
  </tfoot>
                  </table>
                </div>
              </Col>
              <Col xs={12} sm={12} md={7} lg={7} xl={7} xxl={7}>
              <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=" mt-2 mb-3">
                <div
                  id="search-container1"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #ddd",
                    borderRadius: "20px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.3s ease-in-out",
                    backgroundColor: "#fff",
                    padding: "5px 10px",
                    width: "150px",
                    minWidth: "150px",
                  }}
                >
                  <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888" }} />
                  <input
                    type="text"
                    placeholder="Search"
                    value={search2}
                    onChange={(event) => setSearch2(event.target.value)}
                    onFocus={() => {
                      const wrapper = document.getElementById("search-container1");
                      wrapper.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)";
                      wrapper.style.border = "1px solid #353935";
                      wrapper.style.width = "30%";
                    }}
                    onBlur={() => {
                      const wrapper = document.getElementById("search-container1");
                      wrapper.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                      wrapper.style.border = "1px solid #ddd";
                      wrapper.style.width = "150px";
                    }}
                    style={{
                      flex: "1",
                      border: "none",
                      outline: "none",
                      fontSize: "1rem",
                      color: "#333",
                      backgroundColor: "transparent",
                      transition: "color 0.3s ease",
                      minWidth: "0",
                    }}
                  />
                </div>
              </Col>
                <div id="table-scroll" className="" style={{ maxHeight: "400px", overflowY: "auto", overflowX: "hidden" }}>
                  <table className="table table-bordered custom-table table-responsive w-100" id="my-table">
                    <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                      <tr className="text-center">
                        <th colSpan={9} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>
                          <span style={{ color: "black", fontSize: "15px" }}>Periodicity Wise </span>
                        </th>
                      </tr>
                      <tr className="text-center">
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Sl.No.</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }} className="indicator-column">HOD Name</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Monthly</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Quarterly</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Half Yearly</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Annually</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Biennial</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>5 Years</th>
                          <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Total</th>
                      </tr>
                    </thead>

                    <tbody>
                      {filteredData2?.length === 0 || filteredData2?.length === undefined ? (
                        <tr>
                          <td className="text-center" colSpan="9">
                            <b style={{ color: "red" }}>Details Not Found</b>
                          </td>
                        </tr>
                      ) : (
                        (() => {
                          return filteredData2?.map((detail, i) => {
                            return (
                              <tr key={i}>
                                <td style={{ textAlign: "center" }}>{i + 1}</td>
                                <td style={{ textAlign: "left", minWidth: "200px", wordWrap: "break-word", whiteSpace: "normal" }} className="indicator-column">{detail.hod_id}<br/>{detail.dept_name}</td>

                                <td style={{ textAlign: "right" }}>{detail.monthly}</td>
                                <td style={{ textAlign: "right" }}>{detail.quarterly}</td>

                                <td style={{ textAlign: "right" }}>{detail.half_yearly}</td>
                                <td style={{ textAlign: "right" }}>{detail.annually}</td>
                                <td style={{ textAlign: "right" }}>{detail.bi_annual}</td>

                                <td style={{ textAlign: "right" }}>{detail.five_years}</td>
                                <td style={{ textAlign: "right" }}>{detail.quarterly+detail.monthly+detail.annually+detail.half_yearly+detail.bi_annual+detail.five_years}</td>

                              </tr>
                            );
                          });
                        })()
                      )}
                    </tbody>
                     <tfoot style={{ position: "sticky", bottom: "0px" }}>
    <tr style={{ backgroundColor: "#4e835c", fontWeight: "bold" }}>
      <td colSpan={2} style={{ textAlign: "right",backgroundColor: "#4e835c", color: "#fff"}}>Total</td>
      <td style={{  textAlign: "right",backgroundColor: "#4e835c", color: "#fff" }}>
        {filteredData2?.reduce((sum, item) => sum + (parseFloat(item.monthly) || 0), 0)}
      </td>
      <td style={{  textAlign: "right",backgroundColor: "#4e835c", color: "#fff" }}>
        {filteredData2?.reduce((sum, item) => sum + (parseFloat(item.quarterly) || 0), 0)}
      </td>
      <td style={{  textAlign: "right",backgroundColor: "#4e835c", color: "#fff" }}>
        {filteredData2?.reduce((sum, item) => sum + (parseFloat(item.half_yearly) || 0), 0)}
      </td>
      <td style={{  textAlign: "right",backgroundColor: "#4e835c", color: "#fff" }}>
        {filteredData2?.reduce((sum, item) => sum + (parseFloat(item.annually) || 0), 0)}
      </td>
      <td style={{  textAlign: "right",backgroundColor: "#4e835c", color: "#fff" }}>
        {filteredData2?.reduce((sum, item) => sum + (parseFloat(item.bi_annual) || 0), 0)}
      </td>
      <td style={{  textAlign: "right",backgroundColor: "#4e835c", color: "#fff" }}>
        {filteredData2?.reduce((sum, item) => sum + (parseFloat(item.five_years) || 0), 0)}
      </td>
      <td style={{textAlign: "right",backgroundColor: "#4e835c", color: "#fff"}}>
      {
        filteredData2?.reduce((sum, item) => {
          const rowTotal =
          (parseFloat(item.monthly) || 0) +
          (parseFloat(item.quarterly) || 0) +
            (parseFloat(item.half_yearly) || 0) +
            (parseFloat(item.annually) || 0) +
            (parseFloat(item.bi_annual) || 0) +
            (parseFloat(item.five_years) || 0);

          return sum + rowTotal;
        }, 0)
      }
    </td>
    </tr>
  </tfoot>
                  </table>
                </div>
              </Col>
            </Row>
          </>
        ) :
         (
  <>
       
            {filteredData1.length > 0 && (
              <>
                <Row>
                  <div className="sa-title">
                    <h2>{["null",null,""].includes(deptname) ? "" : deptname}</h2>
                  </div>
                </Row>

                <Row className="mb-4 mt-3">
                  <Col xxl={2} xl={4} lg={4} md={6} sm={12} xs={12} className="mb-5">
                    <div className="sa-card sa-card3" style={{ height: "310px" }}>
                      <div className="dept-title">KPI Entry Level</div>
                      <div className="below-table-div">
                        <Table className="no-border-table below-table mb-0">
                          <tbody>
                            <tr>
                              <td>Mandal</td>
                              <td>:</td>
                              <td className="text-end">{mandal_indicators}</td>
                            </tr>
                            <tr>
                              <td>District</td>
                              <td>:</td>
                              <td className="text-end">{district_indicators}</td>
                            </tr>
                            <tr>
                              <td>HOD</td>
                              <td>:</td>
                              <td className="text-end">{state_indicators}</td>
                            </tr>
                            <tr>
                              <td>Secretariat</td>
                              <td>:</td>
                              <td className="text-end">{secretariat_indicators}</td>
                            </tr>
                            <tr>
                              <td>Total</td>
                              <td>:</td>
                              <td className="text-end">{total}</td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </Col>

                  <Col xxl={2} xl={4} lg={4} md={6} sm={12} xs={12} className="mb-5">
                    <div className="sa-card sa-card1" style={{ height: "310px" }}>
                      <div className="dept-title">Periodicity Wise</div>
                      <div className="below-table-div">
                        <Table className="no-border-table below-table mb-0">
                          <tbody>
                            <tr>
                              <td style={{ width: "70%" }}>Monthly</td>
                              <td>:</td>
                              <td className="text-end">{monthly}</td>
                            </tr>
                            <tr>
                              <td>Quarterly</td>
                              <td>:</td>
                              <td className="text-end">{quarterly}</td>
                            </tr>
                            <tr>
                              <td>Annually</td>
                              <td>:</td>
                              <td className="text-end">{annually}</td>
                            </tr>
                            <tr>
                              <td>Half Yearly</td>
                              <td>:</td>
                              <td className="text-end">{half_yearly}</td>
                            </tr>
                            <tr>
                              <td>Biennial</td>
                              <td>:</td>
                              <td className="text-end">{bi_annual}</td>
                            </tr>
                            <tr>
                              <td>Five Years</td>
                              <td>:</td>
                              <td className="text-end">{five_years}</td>
                            </tr>
                            <tr>
                              <td>Total</td>
                              <td>:</td>
                              <td className="text-end">{total}</td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </>
            )}
  </>
) }
      </Container>
    </>
  );
}
